<app-role-page [role]="role"></app-role-page>
